import React, { useEffect, useState } from "react";
import Select from "react-select";
import mainAxios from "../../../services/mainAxios";
import selectStyle from "../../../design/selectStyle";
import { useTranslation } from "react-i18next";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const AddEditPaymentBankAccount = ({ state:existingState,onSave }) => {
const { t } = useTranslation('translations');
    
  const [state,setState]=useState(existingState ?? {
    bank:null,
    purchaseBankAccount:null
  })

  const [bankList,setBankList]=useState([])

  const handleBankAccount=(e)=>{
    const {name,value}=e.target
    setState((state)=>({
        ...state,
        purchaseBankAccount:{
            ...state.purchaseBankAccount,
            [name]:value
        }
    }))
  }


  
 useEffect(()=> {
    mainAxios
    .post("apiEndpoint/search", {
      object: "GetBanks",
      params: {},
    })
    .then( res=>{
      if(res.data.status==true){
        setBankList(res.data.content);
      }
    })
  },[])

  return (
    <div>
      <div className="col-12">
        <div className="form-group">
          <label>{t("bkt.banks")}</label>
          <Select
            // options={payment?.sellerBankAccounts ?? []}
            menuPlacement="auto"
            options={bankList ?? []}
            getOptionLabel={(option) => option?.name}
            getOptionValue={(option) => option?.id}
            styles={selectStyle}
            value={state?.bank}
            onChange={(bank) => {
              setState((state)=>({...state,bank}))
            }}
          />
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="recordDate">IBAN</label>
              <input
                type="text"
                className="form-control"
                name="bankAccountId"
                value={
                  state?.purchaseBankAccount?.bankAccountId
                }
                onChange={handleBankAccount}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="recordDate">Bank Name</label>
              <input
                type="text"
                className="form-control"
                name="bankAccountName"
                value={state?.purchaseBankAccount?.bankAccountName}
                onChange={handleBankAccount}
              />
            </div>
          </div>
          <div className="col-12">
          <button
                    
                //   disabled={loading}
                  style={{ minWidth: "100px" }}
                  className="btn btn-primary"
                  onClick={()=>{
                    onSave(state)
                  }}
                >
                  {/* {loading ? (
                    <Loader size="xs" color="white" />
                  ) : (
                    <> */}
                      <FontAwesomeIcon icon={faCheck} className="mr-2" />
                      {t("common.save")}
                    {/* </>
                  )} */}
                </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEditPaymentBankAccount;
